export enum ConfirmDialog {
  Delete = "Delete",
  Rename = "Rename",
  Save = "Save",
}
